<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">TAXPAYER DATABASE</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">TAXPAYER DATABASE</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Statistics Cards -->
            <div class="row mb-4">
              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Total Taxpayers</p>
                        <h4 class="mb-0">{{ formatNumber(statistics.totalTaxpayers) }}</h4>
                      </div>
                      <div class="text-primary ms-auto">
                        <i class="ri-user-3-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Active Businesses</p>
                        <h4 class="mb-0">{{ formatNumber(statistics.activeBusinesses) }}</h4>
                      </div>
                      <div class="text-success ms-auto">
                        <i class="ri-building-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Revenue Streams</p>
                        <h4 class="mb-0">{{ formatNumber(statistics.revenueStreams) }}</h4>
                      </div>
                      <div class="text-warning ms-auto">
                        <i class="ri-money-dollar-circle-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Monthly Revenue</p>
                        <h4 class="mb-0">{{ formatPrice(statistics.monthlyRevenue) }}</h4>
                      </div>
                      <div class="text-info ms-auto">
                        <i class="ri-line-chart-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Main Content -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- Header -->
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Taxpayer Registry</h4>
                      <div>
                        <button v-if="getRight('SYNC TAXPAYERS')"
                                @click="syncWithKRA"
                                :disabled="syncing"
                                class="btn btn-info me-2">
                          <i v-if="!syncing" class="mdi mdi-sync font-size-16"></i>
                          <div v-else class="spinner-border spinner-border-sm" role="status"></div>
                          <span class="d-md-inline ms-1">{{ syncing ? 'Syncing...' : 'Sync with KRA' }}</span>
                        </button>
                        <button v-if="getRight('ADD TAXPAYER')"
                                @click="openTaxpayerModal()"
                                class="btn btn-primary">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Add Taxpayer</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Taxpayer Type Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Type:</label>
                        <select v-model="filters.taxpayerType" @change="filterTaxpayers" class="form-select">
                          <option value="">All Types</option>
                          <option value="INDIVIDUAL">Individual</option>
                          <option value="BUSINESS">Business</option>
                          <option value="ORGANIZATION">Organization</option>
                        </select>
                      </div>

                      <!-- Status Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Status:</label>
                        <select v-model="filters.status" @change="filterTaxpayers" class="form-select">
                          <option value="">All Status</option>
                          <option value="ACTIVE">Active</option>
                          <option value="INACTIVE">Inactive</option>
                          <option value="SUSPENDED">Suspended</option>
                        </select>
                      </div>

                      <!-- Location Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">County:</label>
                        <select v-model="filters.county" @change="filterTaxpayers" class="form-select">
                          <option value="">All Counties</option>
                          <option v-for="county in counties" :key="county" :value="county">
                            {{ county }}
                          </option>
                        </select>
                      </div>

                      <!-- Revenue Stream Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Revenue Stream:</label>
                        <select v-model="filters.revenueStream" @change="filterTaxpayers" class="form-select">
                          <option value="">All Streams</option>
                          <option v-for="stream in revenueStreams" :key="stream" :value="stream">
                            {{ stream }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-4">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search by name, ID, KRA PIN, phone...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Taxpayer Info</th>
                          <th class="text-nowrap">National ID / Reg No</th>
                          <th class="text-nowrap">KRA PIN</th>
                          <th class="text-nowrap">Contact</th>
                          <th class="text-nowrap">Type</th>
                          <th class="text-nowrap">Revenue Streams</th>
                          <th class="text-nowrap">Locations</th>
                          <th class="text-nowrap text-end">Monthly Revenue</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(taxpayer, index) in paginatedTaxpayers" :key="taxpayer.id">
                          <td class="text-nowrap">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                          <td style="min-width: 200px;">
                            <div class="d-flex align-items-center">
                              <div class="avatar-sm rounded-circle bg-light me-3">
                                <span class="avatar-title rounded-circle bg-primary text-white">
                                  {{ taxpayer.name.charAt(0).toUpperCase() }}
                                </span>
                              </div>
                              <div>
                                <strong>{{ taxpayer.name }}</strong>
                                <small v-if="taxpayer.businessName" class="text-muted d-block">
                                  {{ taxpayer.businessName }}
                                </small>
                                <small class="text-muted d-block">
                                  Registered: {{ taxpayer.registrationDate }}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <strong>{{ taxpayer.nationalId }}</strong>
                              <small v-if="taxpayer.businessRegNo" class="text-muted d-block">
                                Reg: {{ taxpayer.businessRegNo }}
                              </small>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <span class="fw-bold">{{ taxpayer.kraPin }}</span>
                          </td>
                          <td class="text-nowrap">
                            <div>
                              <div>{{ maskPhoneNumber(taxpayer.phone) }}</div>
                              <small class="text-muted">{{ taxpayer.email }}</small>
                            </div>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge" :class="getTaxpayerTypeClass(taxpayer.type)">
                              {{ taxpayer.type }}
                            </span>
                          </td>
                          <td style="min-width: 200px;">
                            <div class="d-flex flex-wrap gap-1">
                              <span v-for="stream in taxpayer.revenueStreams"
                                    :key="stream.type"
                                    class="badge bg-light text-dark border">
                                {{ stream.type }}
                              </span>
                            </div>
                            <small class="text-muted">{{ taxpayer.revenueStreams.length }} stream(s)</small>
                          </td>
                          <td style="min-width: 150px;">
                            <div>
                              <div v-for="location in taxpayer.locations" :key="location" class="text-muted">
                                <small>• {{ location }}</small>
                              </div>
                            </div>
                          </td>
                          <td class="text-nowrap text-end">
                            <span class="fw-semibold">{{ formatPrice(taxpayer.monthlyRevenue) }}</span>
                          </td>
                          <td class="text-nowrap">
                            <span class="badge" :class="getStatusClass(taxpayer.status)">
                              {{ taxpayer.status }}
                            </span>
                          </td>
                          <td class="text-nowrap">
                            <div class="d-flex gap-1">
                              <button @click="viewTaxpayerDetails(taxpayer)"
                                      class="btn btn-primary btn-sm"
                                      data-bs-toggle="modal"
                                      data-bs-target="#taxpayerDetailsModal">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <button @click="openTaxpayerModal(taxpayer)"
                                      class="btn btn-outline-secondary btn-sm">
                                <i class="mdi mdi-pencil"></i>
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li><a class="dropdown-item" @click="viewRevenueHistory(taxpayer)">
                                    <i class="mdi mdi-chart-line me-2"></i>Revenue History</a></li>
                                  <li><a class="dropdown-item" @click="generateTaxpayerReport(taxpayer)">
                                    <i class="mdi mdi-file-document me-2"></i>Generate Report</a></li>
                                  <li><a class="dropdown-item" @click="syncTaxpayerData(taxpayer)">
                                    <i class="mdi mdi-sync me-2"></i>Sync Data</a></li>
                                  <li><hr class="dropdown-divider"></li>
                                  <li><a class="dropdown-item text-warning" @click="suspendTaxpayer(taxpayer)">
                                    <i class="mdi mdi-pause me-2"></i>Suspend</a></li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- Loading State -->
                      <div v-if="loading" class="text-center p-5">
                        <div class="spinner-border text-info mb-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <h4>Loading Taxpayers</h4>
                        <p>We are fetching the taxpayer data for you. Please wait...</p>
                      </div>

                      <!-- No Results -->
                      <div v-if="filteredTaxpayers.length < 1 && !loading" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Taxpayers Found</h4>
                        <p>Sorry, we could not find any taxpayers that match your search or filter criteria.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                      </div>

                      <div class="d-flex align-items-center">
                        <span class="me-3">
                          Showing {{ (currentPage - 1) * pageSize + 1 }} to
                          {{ Math.min(currentPage * pageSize, filteredTaxpayers.length) }}
                          of {{ filteredTaxpayers.length }} entries
                        </span>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in visiblePages" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Taxpayer Details Modal -->
        <TaxpayerDetailsModal
            :taxpayer="selectedTaxpayer"
            @edit-taxpayer="openTaxpayerModal"
        />

        <!-- Add/Edit Taxpayer Modal -->
        <TaxpayerFormModal
            :taxpayer="editingTaxpayer"
            :isEditing="isEditing"
            @save-taxpayer="saveTaxpayer"
        />

        <!-- Revenue History Modal -->
        <RevenueHistoryModal
            :taxpayer="selectedTaxpayer"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import TaxpayerDetailsModal from "@/components/taxpayers/modals/TaxpayerDetailsModal.vue";
import TaxpayerFormModal from "@/components/taxpayers/modals/TaxpayerFormModal.vue";
import RevenueHistoryModal from "@/components/taxpayers/modals/RevenueHistoryModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "TaxpayerDatabase",
  components: {
    NavigationBar,
    TaxpayerDetailsModal,
    TaxpayerFormModal,
    RevenueHistoryModal
  },
  data() {
    return {
      loading: false,
      syncing: false,
      search: '',
      currentPage: 1,
      pageSize: 10,

      // Filters
      filters: {
        taxpayerType: '',
        status: '',
        county: '',
        revenueStream: ''
      },

      // Filter options
      counties: [
        'Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Thika', 'Malindi', 'Kitale'
      ],
      revenueStreams: [
        'Single Business Permit', 'Liquor License', 'Land Rates', 'Market Fees',
        'Parking Fees', 'Building Plan Approval', 'Billboard Advertising', 'Fire Certificate'
      ],

      // Statistics
      statistics: {
        totalTaxpayers: 15847,
        activeBusinesses: 12450,
        revenueStreams: 8,
        monthlyRevenue: 245780000
      },

      // Taxpayers data
      taxpayers: [
        {
          id: 1,
          name: "John Mwangi Kamau",
          businessName: "Eastgate Shopping Mall",
          nationalId: "28745692",
          businessRegNo: "CPR/2018/145789",
          kraPin: "A012345678K",
          phone: "+254712345678",
          email: "john.kamau@eastgate.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2018-03-15",
          monthlyRevenue: 2500000,
          locations: ["Nairobi - CBD", "Nakuru - Town", "Kisumu - Kondele"],
          revenueStreams: [
            { type: "SBP", amount: 150000, location: "Nairobi" },
            { type: "Billboard", amount: 80000, location: "Nairobi" },
            { type: "Parking Fees", amount: 200000, location: "Nairobi" },
            { type: "Market Fees", amount: 120000, location: "Nakuru" }
          ]
        },
        {
          id: 2,
          name: "Mary Wanjiku Njuguna",
          businessName: "Elite Motors & Garage",
          nationalId: "31856479",
          businessRegNo: "CPR/2019/287456",
          kraPin: "A023456789L",
          phone: "+254723456789",
          email: "mary.njuguna@elitemotors.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2019-07-22",
          monthlyRevenue: 850000,
          locations: ["Nairobi - Industrial Area", "Thika - Town"],
          revenueStreams: [
            { type: "SBP", amount: 85000, location: "Nairobi" },
            { type: "Fire Certificate", amount: 15000, location: "Nairobi" },
            { type: "SBP", amount: 45000, location: "Thika" }
          ]
        },
        {
          id: 3,
          name: "Samuel Kipchoge Rotich",
          businessName: "Rift Valley Outdoor Advertising",
          nationalId: "25987413",
          businessRegNo: "CPR/2017/198765",
          kraPin: "A034567890M",
          phone: "+254734567890",
          email: "samuel.rotich@riftvalleyadv.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2017-11-08",
          monthlyRevenue: 1200000,
          locations: ["Nakuru - Highway", "Eldoret - Airport Road", "Kisumu - Kondele", "Nairobi - Thika Road"],
          revenueStreams: [
            { type: "Billboard", amount: 300000, location: "Nairobi" },
            { type: "Billboard", amount: 250000, location: "Nakuru" },
            { type: "Billboard", amount: 200000, location: "Eldoret" },
            { type: "Billboard", amount: 180000, location: "Kisumu" }
          ]
        },
        {
          id: 4,
          name: "Grace Achieng Odhiambo",
          businessName: "Lakeview Restaurant & Catering",
          nationalId: "29753681",
          businessRegNo: "CPR/2020/345821",
          kraPin: "A045678901N",
          phone: "+254745678901",
          email: "grace.odhiambo@lakeviewrest.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2020-02-14",
          monthlyRevenue: 450000,
          locations: ["Kisumu - Milimani", "Kisumu - Tom Mboya Estate"],
          revenueStreams: [
            { type: "SBP", amount: 75000, location: "Kisumu" },
            { type: "Liquor License", amount: 35000, location: "Kisumu" },
            { type: "Fire Certificate", amount: 12000, location: "Kisumu" }
          ]
        },
        {
          id: 5,
          name: "David Maina Wachira",
          businessName: null,
          nationalId: "32147859",
          businessRegNo: null,
          kraPin: "A056789012O",
          phone: "+254756789012",
          email: "david.wachira@gmail.com",
          type: "INDIVIDUAL",
          status: "ACTIVE",
          registrationDate: "2021-05-10",
          monthlyRevenue: 285000,
          locations: ["Nairobi - Kiambu Road", "Thika - Section 7"],
          revenueStreams: [
            { type: "Land Rates", amount: 180000, location: "Nairobi" },
            { type: "Land Rates", amount: 105000, location: "Thika" }
          ]
        },
        {
          id: 6,
          name: "Catherine Mumbi Kariuki",
          businessName: "Mumbi Fashion House",
          nationalId: "27894563",
          businessRegNo: "CPR/2016/789123",
          kraPin: "A067890123P",
          phone: "+254767890123",
          email: "catherine.kariuki@mumbifashion.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2016-09-30",
          monthlyRevenue: 320000,
          locations: ["Nairobi - Westlands", "Nakuru - Town Center"],
          revenueStreams: [
            { type: "SBP", amount: 95000, location: "Nairobi" },
            { type: "SBP", amount: 55000, location: "Nakuru" },
            { type: "Fire Certificate", amount: 18000, location: "Nairobi" }
          ]
        },
        {
          id: 7,
          name: "Robert Kiprotich Lagat",
          businessName: "Highland Hardware Stores",
          nationalId: "30654987",
          businessRegNo: "CPR/2019/456789",
          kraPin: "A078901234Q",
          phone: "+254778901234",
          email: "robert.lagat@highland.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2019-12-18",
          monthlyRevenue: 680000,
          locations: ["Eldoret - Town", "Kitale - Market Area", "Nakuru - Section 58"],
          revenueStreams: [
            { type: "SBP", amount: 120000, location: "Eldoret" },
            { type: "SBP", amount: 85000, location: "Kitale" },
            { type: "SBP", amount: 75000, location: "Nakuru" },
            { type: "Fire Certificate", amount: 25000, location: "Eldoret" }
          ]
        },
        {
          id: 8,
          name: "Joyce Nyawira Muthoni",
          businessName: "Central Kenya Transport",
          nationalId: "26741853",
          businessRegNo: "CPR/2015/963741",
          kraPin: "A089012345R",
          phone: "+254789012345",
          email: "joyce.muthoni@cktransport.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2015-06-25",
          monthlyRevenue: 1850000,
          locations: ["Nairobi - River Road", "Thika - Town", "Nakuru - Matatu Stage", "Nyeri - Town"],
          revenueStreams: [
            { type: "SBP", amount: 250000, location: "Nairobi" },
            { type: "Parking Fees", amount: 350000, location: "Nairobi" },
            { type: "SBP", amount: 150000, location: "Thika" },
            { type: "SBP", amount: 180000, location: "Nakuru" },
            { type: "Parking Fees", amount: 200000, location: "Nakuru" }
          ]
        },
        {
          id: 9,
          name: "Peter Macharia Kamau",
          businessName: "Mt. Kenya Breweries",
          nationalId: "28963741",
          businessRegNo: "CPR/2018/741258",
          kraPin: "A090123456S",
          phone: "+254790123456",
          email: "peter.kamau@mtkenyabreweries.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2018-08-12",
          monthlyRevenue: 3200000,
          locations: ["Nyeri - Industrial Area", "Nakuru - Pipeline"],
          revenueStreams: [
            { type: "SBP", amount: 450000, location: "Nyeri" },
            { type: "Liquor License", amount: 850000, location: "Nyeri" },
            { type: "Fire Certificate", amount: 85000, location: "Nyeri" },
            { type: "Building Plan", amount: 125000, location: "Nakuru" }
          ]
        },
        {
          id: 10,
          name: "Agnes Wanjiru Ndung'u",
          businessName: "Wanjiru Medical Supplies",
          nationalId: "31478529",
          businessRegNo: "CPR/2020/852741",
          kraPin: "A101234567T",
          phone: "+254701234567",
          email: "agnes.wanjiru@medisupplies.co.ke",
          type: "BUSINESS",
          status: "ACTIVE",
          registrationDate: "2020-11-03",
          monthlyRevenue: 780000,
          locations: ["Nairobi - Upper Hill", "Thika - Hospital Road"],
          revenueStreams: [
            { type: "SBP", amount: 185000, location: "Nairobi" },
            { type: "Fire Certificate", amount: 35000, location: "Nairobi" },
            { type: "SBP", amount: 95000, location: "Thika" }
          ]
        }
      ],

      filteredTaxpayers: [],
      selectedTaxpayer: {},
      editingTaxpayer: {},
      isEditing: false,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  computed: {
    paginatedTaxpayers() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredTaxpayers.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredTaxpayers.length / this.pageSize);
    },

    visiblePages() {
      const maxVisible = 5;
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= maxVisible) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 3; i <= total; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    }
  },
  watch: {
    search() {
      this.filterTaxpayers();
    },
    pageSize() {
      this.currentPage = 1;
    }
  },
  mounted() {
    this.filteredTaxpayers = [...this.taxpayers];
    this.menuAccess();
  },
  methods: {
    getRight,

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0
      }).format(value);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-US').format(value);
    },

    maskPhoneNumber(phone) {
      if (!phone) return '';
      return phone.slice(0, 6) + '*'.repeat(phone.length - 8) + phone.slice(-2);
    },

    getTaxpayerTypeClass(type) {
      switch (type) {
        case 'INDIVIDUAL':
          return 'bg-info';
        case 'BUSINESS':
          return 'bg-success';
        case 'ORGANIZATION':
          return 'bg-warning';
        default:
          return 'bg-secondary';
      }
    },

    getStatusClass(status) {
      switch (status) {
        case 'ACTIVE':
          return 'bg-success';
        case 'INACTIVE':
          return 'bg-secondary';
        case 'SUSPENDED':
          return 'bg-danger';
        default:
          return 'bg-secondary';
      }
    },

    gotTo(route) {
      router.push(route);
    },

    filterTaxpayers() {
      let filtered = [...this.taxpayers];

      // Filter by search
      if (this.search.trim()) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter(taxpayer =>
            taxpayer.name.toLowerCase().includes(searchTerm) ||
            taxpayer.nationalId.includes(searchTerm) ||
            taxpayer.kraPin.toLowerCase().includes(searchTerm) ||
            taxpayer.phone.includes(searchTerm) ||
            taxpayer.email.toLowerCase().includes(searchTerm) ||
            (taxpayer.businessName && taxpayer.businessName.toLowerCase().includes(searchTerm))
        );
      }

      // Filter by type
      if (this.filters.taxpayerType) {
        filtered = filtered.filter(taxpayer => taxpayer.type === this.filters.taxpayerType);
      }

      // Filter by status
      if (this.filters.status) {
        filtered = filtered.filter(taxpayer => taxpayer.status === this.filters.status);
      }

      // Filter by county
      if (this.filters.county) {
        filtered = filtered.filter(taxpayer =>
            taxpayer.locations.some(location => location.includes(this.filters.county))
        );
      }

      // Filter by revenue stream
      if (this.filters.revenueStream) {
        filtered = filtered.filter(taxpayer =>
            taxpayer.revenueStreams.some(stream =>
                stream.type.toLowerCase().includes(this.filters.revenueStream.toLowerCase())
            )
        );
      }

      this.filteredTaxpayers = filtered;
      this.currentPage = 1;
    },

    async syncWithKRA() {
      try {
        this.syncing = true;

        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 3000));

        this.message = "Successfully synced with KRA database. 3 new taxpayers added, 5 records updated.";
        this.alert.success = true;
        this.syncing = false;

        // Auto-hide alert
        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 5000);
      } catch (e) {
        this.syncing = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    viewTaxpayerDetails(taxpayer) {
      this.selectedTaxpayer = taxpayer;
    },

    openTaxpayerModal(taxpayer = null) {
      this.isEditing = !!taxpayer;
      this.editingTaxpayer = taxpayer ? { ...taxpayer } : {
        name: '',
        businessName: '',
        nationalId: '',
        businessRegNo: '',
        kraPin: '',
        phone: '',
        email: '',
        type: 'INDIVIDUAL',
        status: 'ACTIVE',
        locations: [],
        revenueStreams: []
      };

      const modalElement = document.getElementById('taxpayerFormModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    saveTaxpayer(taxpayerData) {
      try {
        if (this.isEditing) {
          // Update existing taxpayer
          const index = this.taxpayers.findIndex(t => t.id === taxpayerData.id);
          if (index > -1) {
            this.taxpayers[index] = { ...taxpayerData };
            this.message = "Taxpayer updated successfully!";
          }
        } else {
          // Add new taxpayer
          const newId = Math.max(...this.taxpayers.map(t => t.id)) + 1;
          taxpayerData.id = newId;
          taxpayerData.registrationDate = moment().format('YYYY-MM-DD');
          this.taxpayers.unshift(taxpayerData);
          this.message = "Taxpayer added successfully!";
        }

        this.alert.success = true;
        this.filterTaxpayers();

        // Close modal
        const modalElement = document.getElementById('taxpayerFormModal');
        if (modalElement) {
          const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
          if (bootstrapModal) {
            bootstrapModal.hide();
          }
        }

        // Auto-hide alert
        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      } catch (e) {
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    viewRevenueHistory(taxpayer) {
      this.selectedTaxpayer = taxpayer;

      const modalElement = document.getElementById('revenueHistoryModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    generateTaxpayerReport(taxpayer) {
      this.message = `Generating comprehensive report for ${taxpayer.name}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    syncTaxpayerData(taxpayer) {
      this.message = `Syncing data for ${taxpayer.name} with external databases...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `Data synced successfully for ${taxpayer.name}`;
        this.alert.success = true;
      }, 2000);
    },

    suspendTaxpayer(taxpayer) {
      if (confirm(`Are you sure you want to suspend ${taxpayer.name}?`)) {
        taxpayer.status = 'SUSPENDED';
        this.message = `${taxpayer.name} has been suspended`;
        this.alert.info = true;

        setTimeout(() => {
          this.alert.info = false;
          this.message = '';
        }, 3000);
      }
    },

    // Pagination methods
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Taxpayer Database");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.border {
  border-color: #dee2e6 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}
</style>